// Operator-facing message for /team lifecycle actions (edit / deactivate /
// reactivate). Maps the backend's DISTINCT codes (restful handler/common.go) so an
// operator sees an actionable reason instead of a raw code — mirrors the shared
// _shared/actionError.ts pattern for the user/device action bars.

import { ApiError } from '../../lib/api';

export function teamActionErrorMessage(e: unknown): string {
  if (!(e instanceof ApiError)) return '操作失敗，請稍後再試。';
  switch (e.code) {
    case 'CANNOT_DEACTIVATE_OWNER':
      return '無法停用平台擁有者帳號：擁有者異動走線下流程，不經此功能。（CANNOT_DEACTIVATE_OWNER）';
    case 'CANNOT_SELF_DEACTIVATE':
      return '無法停用自己的帳號。';
    case 'INVALID_STATE_TRANSITION':
      return '此帳號目前狀態無法執行這項操作（僅維運帳號、且狀態相符時可用）。';
    case 'BUSINESS_RULE_VIOLATION':
      return '顯示名稱需為 1–32 個字。';
  }
  if (e.status === 403) {
    return `權限不足：此操作僅限平台擁有者（${e.code}）。`;
  }
  return `${e.message}（${e.code}）`;
}
